import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CollapseComponent } from './collapse/collapse.component';
import { IconModule } from '../icon/icon.module';



@NgModule({
  declarations: [CollapseComponent],
  exports: [
    CollapseComponent
  ],
  imports: [
    CommonModule,
    IconModule
  ]
})
export class CollapseModule { }
